module.exports = __webpack_public_path__ + "static/media/mongo.fcb7b7b1.jpg";